import { Permission } from './permission.types'

/** Post-login / home redirect priority (first match wins). */
export const DEFAULT_ROUTE_CANDIDATES: ReadonlyArray<{ path: string; permission: Permission }> = [
  { path: '/home', permission: Permission.HomeView },
  { path: '/sala-espera', permission: Permission.AgendaOwn },
  { path: '/pacientes', permission: Permission.PatientsList },
  { path: '/historial-consultas', permission: Permission.ConsultationsHistory },
  { path: '/mi-perfil', permission: Permission.ProfileView },
]

/** Route → required permissions (any). Used for tests and documentation. */
export const ROUTE_PERMISSION_MAP: ReadonlyArray<{ path: string; permissions: Permission[] }> = [
  { path: '/home', permissions: [Permission.HomeView] },
  { path: '/sala-espera', permissions: [Permission.AgendaOwn] },
  { path: '/calendario-consultas', permissions: [Permission.AgendaOwn] },
  { path: '/mi-perfil', permissions: [Permission.ProfileView] },
  { path: '/ausencias', permissions: [Permission.AbsencesOwn, Permission.AbsencesTeam] },
  { path: '/historial-consultas', permissions: [Permission.ConsultationsHistory] },
  { path: '/crear-consulta', permissions: [Permission.ConsultationsCreate] },
  { path: '/pacientes', permissions: [Permission.PatientsList] },
  { path: '/importacion-pacientes', permissions: [Permission.PatientsImport] },
  { path: '/gestion-medicos', permissions: [Permission.TeamManageDoctors] },
  { path: '/gestion-operadores', permissions: [Permission.TeamManageOperators] },
  { path: '/agenda-equipo', permissions: [Permission.TeamAgenda] },
  { path: '/preguntas_frecuentes', permissions: [Permission.Faq] },
  {
    path: '/ficha-consulta',
    permissions: [Permission.ConsultationAttend, Permission.TeamAgenda],
  },
]
